import axiosInstance from '@/utils/api.js'

var state = {
  userServicesLinksAcc: [],
  periodicServiceLinkStats: null
}

var getters = {
  USER_SERVICES_LINKS_ACC: (state) => {
    return state.userServicesLinksAcc
  },
  PERIODIC_SERVICE_LINK_STATS: (state) => {
    return state.periodicServiceLinkStats
  }
}

var mutations = {
  SET_USER_SERVICES_LINKS_ACC: (state, payload) => {
    state.userServicesLinksAcc = payload || []
  },
  SET_PERIODIC_SERVICE_LINK_STATS: (state, payload) => {
    state.periodicServiceLinkStats = payload || []
  }
}

var actions = {
  TRANSFER_SERVICE_LINKS: async (context, payload) => {
    return axiosInstance.post('/users/servicelinks/transfer', payload)
  },
  GET_USER_SERVICES_LINKS_ACC: async (context, payload) => {
    let result = await axiosInstance.get('/users/servicelinks?account_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_USER_SERVICES_LINKS_ACC', result.data)
    }
  },
  DELETE_USER_SERVICES_LINKS: (context, payload) => {
    return axiosInstance.delete('/users/servicelinks', {data: { 'slink_id': payload }})
  },
  CREATE_COEFFICIENT_SCHEDLE: (context, payload) => {
    return axiosInstance.post('/tariffing/coefficient_schedule', payload)
  },
  CREATE_UERS_SERVICELINKS_COEFFICIENT_SCHEDLE: (context, payload) => {
    return axiosInstance.post('/users/servicelinks/coefficient_schedule', payload)
  },
  GET_PERIODIC_SERVICE_LINK_STATS: async (context, payload) => {
    let result = await axiosInstance.get('/users/servicelinks/periodic_slink_stats?slink_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_PERIODIC_SERVICE_LINK_STATS', result.data)
    }
  },
  CREATE_UERS_ENABLE_TURBO_MODE: (context, payload) => {
    return axiosInstance.post('/users/servicelinks/enable_turbo_mode', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/servicesLinks.js